export default __webpack_public_path__ + "static/restauration_aside_cover-ba07da2861932c1330ad94b33e427ae1.jpg";